<template>
  <v-list-item two-line>
    <v-list-item-content>
      <v-list-item-title>{{title}}</v-list-item-title>
      <v-list-item-subtitle v-if="author">Author: {{ author.first_name + ' ' + author.last_name }}</v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action>
      <v-row>
        <v-btn rounded text @click="$emit('show', uuid)">
          show
          <v-icon right>mdi-open-in-new</v-icon>
        </v-btn>

        <v-btn
          color="primary"
          v-if="status != 'published'"
          rounded
          text
          @click="$emit('publish', uuid)"
        >
          Enable
          <v-icon right>mdi-eye</v-icon>
        </v-btn>
        <v-btn color="primary" v-else rounded text @click="$emit('unpublish', uuid)">
          Disable
          <v-icon right>mdi-eye-off</v-icon>
        </v-btn>
      </v-row>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
export default {
  props: ["title", "uuid", "status", "author"]
};
</script>

<style lang="scss" scoped></style>
